
<template>
  <div class="bg-white">
    <div class="agreement">
      <p class="p">尊敬的用户，为保障您的合法权益，请您在对平台余额充值前仔细阅读本协议，当您点击“立即充值”按钮后，即视为您已阅读、理解本协议，并同意按本协议的规定参与充值。</p>
      <p class="step">1 充值说明</p>
      <p class="p">1.1 平台充电的收费服务具有不允许欠费校验，因此您使用服务时建议预先充值10元（低于10元将无法开始充电服务）及以上金额人民币。充值方法可根据充电平台上我的-充值步骤指示完成；</p>
      <p class="p">1.2 平台充电有权对用户进行充值满额赠送等促销活动；</p>
      <p class="p">1.3 单笔充值金额上限为2000元。</p>
      <p class="p">1.4 充电充值次数不做限制。</p>
      <p class="step">2 余额说明</p>
      <p class="p1">2.1 余额构成</p>
      <p class="p">余额是指您实际充值的本金加上平台的返现金额构成的账户余额（人民币）。</p>
      <p class="p1">2.2 充值余额有效期</p>
      <p class="p">充值及返现金额有效期限为自充值日起至用完即止。</p>
      <p class="p1">2.3 余额使用规则</p>
      <p class="p">无论是账户余额或平台充电的赠送都只能用于支付平台充电内涉及的所有预约费、电费、服务费，不支持转移、转赠，赠送金额不支持提现；</p>
      <p class="p1">2.4 余额不足或欠款说明</p>
      <p class="p">由于您的平台充电账户余额不足，可能会导致充电服务终止，由您自行承担责任，平台对此不承担责任。</p>
      <p class="p1">2.5 余额退款规则</p>
      <p class="p">若您需要进行余额退款，退款申请方法可根据平台上申请退款步骤指示完成，平台会在您申请退款服务之日起10-15个工作日内为您退款。</p>
      <p class="p1">2.6 正当性保护</p>
      <p class="p">我们包含充值赠送在内的所有优惠推广活动仅面向正当、合法使用我们充电服务的用户。一旦您存在利用我们的规则漏洞进行任何形式的作弊行为（包括但不限于通过我们的活动获得不正当的经济利益），我们有权取消与作弊行为相关账户赠送金额、追回您作弊所得的不正当经济利益、关闭作弊账户或与您相关所有账户，并保留取消您后续使用我们服务的权限，及依据严重程度追究您的法律责任。</p>
      <p class="step">3 账户安全</p>
      <p class="p">3.1 您应自行设置平台账号的登录密码和支付密码，并予以妥善保管。若您泄露了账户的登录密码和支付密码等，由此引起的账号被盗及该账户内充值余额被盗用等风险和损失应由您自行承担，您不得将此作为取消交易、拒绝付款的理由；</p>
      <p class="p">3.2 如您发现平台充电账号被盗用，建议及时联系平台找回账号。</p>
      <p class="step">4 管辖与法律适用</p>
      <p class="p">4.1 本协议签订地为中华人民共和国广东省深圳市南山区；</p>
      <p class="p">4.2 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）；</p>
      <p class="p">4.3 若您和平台之间因本协议发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交至本协议签订地有管辖权的人民法院管辖；</p>
      <p class="p">4.4 本协议条款无论因何种原因部分无效，其余条款仍有效，对各方具有约束力。</p>
      <p class="step">5 其他</p>
      <p class="p">平台有权在必要时变更本协议条款，您可以在平台充电的相关页面查阅最新版本的协议条款。</p>
      <p class="p">本协议条款变更后，如果您继续使用平台服务，即视为您已接受变更后的协议。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'change-agreement',
  data () {
    return {

    };
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/old/var.less";

.agreement {
  padding: 0.4rem 0.2rem;
  .title {
    .size;
    color: #000;
    text-align: center;
    margin-bottom: 0.4rem;
  }
  p {
    line-height: 0.4rem;
  }
  .step {
    margin: 0.4rem 0 0.15rem 0;
    color: #000;
  }
  .p {
    text-indent: 2em;
    color: #999;
  }
  .p1 {
    text-indent: 1em;
    margin: 0.1rem 0;
    color: #666;
  }
}
</style>
